import React, { useMemo } from "react";
import MetricStatCard, { METRIC_STATS_GRID_CLASS } from "../../../shared/components/MetricStatCard";
import { useTranslation } from "../../../i18n";

function metricValue(stats, key) {
  switch (key) {
    case "total":
      return stats.total;
    case "pending":
      return stats.pending;
    case "in_progress":
      return stats.inProgress;
    case "completed":
      return stats.completed;
    case "rejected":
      return stats.rejected;
    default:
      return 0;
  }
}

const DeletionCasesMetricsCards = ({
  stats,
  loading = false,
  activeStatus = "",
  activeStatusGroup = "",
  activeCreatedWithinDays = null,
  onFilterChange,
}) => {
  const { t } = useTranslation();

  const metricCards = useMemo(
    () => [
      {
        key: "total",
        label: t("metrics.casesTotal"),
        hint: t("metrics.casesTotalHint"),
        borderClass: "border-primary",
        filterStatus: "",
        filterStatusGroup: "",
        icon: "assignment",
        iconTone: "primary",
        badge: (s) =>
          s.newThisWeek > 0 ? t("metrics.casesNewThisMonth", { count: s.newThisWeek }) : null,
        badgeClass: "text-secondary text-xs font-semibold",
      },
      {
        key: "pending",
        label: t("metrics.casesPending"),
        hint: t("metrics.casesPendingHint"),
        borderClass: "border-yellow-500",
        filterStatusGroup: "pending",
        icon: "schedule",
        iconTone: "yellow",
      },
      {
        key: "in_progress",
        label: t("metrics.casesInProgress"),
        hint: t("metrics.casesInProgressHint"),
        borderClass: "border-secondary",
        filterStatusGroup: "in_progress",
        icon: "trending_up",
        iconTone: "secondary",
      },
      {
        key: "completed",
        label: t("metrics.casesCompleted"),
        hint: t("metrics.casesCompletedHint"),
        borderClass: "border-green-600",
        filterStatusGroup: "completed",
        icon: "check_circle",
        iconTone: "green",
      },
      {
        key: "rejected",
        label: t("metrics.casesRejected"),
        hint: t("metrics.casesRejectedHint"),
        borderClass: "border-error",
        filterStatusGroup: "rejected",
        icon: "cancel",
        iconTone: "error",
      },
    ],
    [t]
  );

  if (loading) {
    return (
      <div className={METRIC_STATS_GRID_CLASS}>
        {[1, 2, 3, 4, 5].map((i) => (
          <div
            key={i}
            className="tonal-card h-[140px] animate-pulse rounded-xl border-l-4 border-outline-variant"
          />
        ))}
      </div>
    );
  }

  if (!stats) return null;

  const isActive = (card) => {
    if (card.key === "total") {
      return !activeStatus && !activeStatusGroup && !activeCreatedWithinDays;
    }
    if (card.filterStatusGroup) {
      return activeStatusGroup === card.filterStatusGroup;
    }
    return false;
  };

  return (
    <div className={METRIC_STATS_GRID_CLASS}>
      {metricCards.map((card) => {
        const active = isActive(card);
        const value = metricValue(stats, card.key);
        const badge = card.badge?.(stats);

        return (
          <MetricStatCard
            key={card.key}
            label={card.label}
            hint={card.hint}
            value={value}
            icon={card.icon}
            iconTone={card.iconTone}
            borderClass={card.borderClass}
            active={active}
            badge={badge}
            badgeClass={card.badgeClass}
            onClick={() =>
              onFilterChange?.({
                status: card.filterStatus ?? "",
                statusGroup: card.filterStatusGroup ?? "",
                createdWithinDays: null,
              })
            }
          />
        );
      })}
    </div>
  );
};

export default DeletionCasesMetricsCards;
